import React from "react";
import { Briefcase, MapPin } from "lucide-react";
import { Card } from "antd";

const JobPostCard = ({ recordData, handleSelect}) => {

  return (
      <Card
        onClick={() => handleSelect(recordData)}
        className="flex flex-col rounded-xl hover:shadow-lg relative bg-white border-2 space-y-2"
      >
        <div className="flex items-start gap-3">
          <div className="flex-1 min-w-0">
            <h4 className="font-medium text-[18px]">{recordData?.jpo_title}</h4>
            <div className="inline-flex items-center">
              <p className="text-base text-slate-500">{recordData?.jpo_job_overview}</p>
            </div>
          </div>
        </div>

        <div className="mt-3 flex gap-3">
          <div className="flex items-center gap-1">
            <span className="flex items-center justify-center w-8 h-8 rounded-lg icon-effect gradient-light-purple">
              <Briefcase className="w-4 h-4 text-purple-600" />
            </span>
            <span className="text-[15px] font-medium">{recordData?.department_name}</span>
          </div>

          <div className="flex items-center gap-1">
            <span className="flex items-center justify-center w-8 h-8 rounded-lg icon-effect gradient-light-emerald">
              <MapPin className="w-4 h-4 text-emerald-600" />
            </span>
            <span className="text-[15px] font-medium">{recordData?.location_name}</span>
          </div>

          <div className="flex w-full items-center gap-1">
            <p className="w-full text-sm text-slate-500 text-right">{recordData?.posted_since}</p>
          </div>
        </div>
      </Card>
  );
};

export default JobPostCard;
